module.exports = __webpack_public_path__ + "static/img/news12.62c2806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news12.jpg
// module id = QUWm
// module chunks = 1